import styled from 'styled-components';

const HeaderText = styled.h4`
  font-family: ${({ theme }) => theme.font.family.websiteMedium};
  font-size: 50px;
  font-weight: bold;
  cursor: default;
  color: #0087c1;
  margin: 0;
  padding-left: 36px;
  ${(p) => p.theme.max('md')`
    font-size: 30px;
  `}
  ${(p) => p.theme.max('sm')`
    font-size: 20px;
  `}
`;

export default HeaderText;
